import React from "react";

export default function Footer() {
  return (
    <footer className="bg-black text-white" data-testid="site-footer">
      <div className="stripe-yellow h-4 w-full" />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 py-12 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-6">
          <div className="font-heading uppercase text-3xl md:text-4xl tracking-tight">
            CUSTOMADE<span className="text-[#FF0055]">.</span>
          </div>
          <p className="mt-3 max-w-md text-white/70 text-sm leading-relaxed">
            Custom printing & apparel for teams, brands and anyone who wants to show up in style.
            Bulk orders welcome. Small runs too.
          </p>
        </div>
        <div className="col-span-6 md:col-span-3">
          <div className="font-heading uppercase text-xs tracking-[0.3em] text-white/50 mb-3">Reach us</div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="tel:8169272803" className="hover:text-[#FFE600]" data-testid="footer-phone">
                +91 81692 72803
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/918169272803"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#FFE600]"
                data-testid="footer-whatsapp"
              >
                WhatsApp
              </a>
            </li>
            <li className="text-white/70">hello@customade.in</li>
          </ul>
        </div>
        <div className="col-span-6 md:col-span-3">
          <div className="font-heading uppercase text-xs tracking-[0.3em] text-white/50 mb-3">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#services" className="hover:text-[#FFE600]">Services</a></li>
            <li><a href="#portfolio" className="hover:text-[#FFE600]">Portfolio</a></li>
            <li><a href="#process" className="hover:text-[#FFE600]">Process</a></li>
            <li><a href="#faq" className="hover:text-[#FFE600]">FAQ</a></li>
            <li><a href="#contact" className="hover:text-[#FFE600]">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/20">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 py-5 flex flex-wrap items-center justify-between gap-3 text-xs text-white/60">
          <div>© {new Date().getFullYear()} Customade. All rights reserved.</div>
          <div className="font-heading uppercase tracking-[0.3em]">Printed with love · Mumbai</div>
        </div>
      </div>
    </footer>
  );
}
